export default "__VITE_ASSET__Dj8sFITS__"